import "../Info/Notifications/SiteConfigurationGroupNotificationsInfoComponent";
import "./Edit/ConfigurationGroupReportingEditComponent";
import "./SiteConfigurationGroupReporting.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import SiteConfigurationGroupReportingComponentController from "./SiteConfigurationGroupReportingComponentController";

export class SiteConfigurationGroupReportingComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {
            configurationGroup: "<",
            deleted: "&",
        };
        this.controller = SiteConfigurationGroupReportingComponentController;
        this.templateUrl = "/App/Components/Site/ConfigurationGroups/Reporting/SiteConfigurationGroupReporting.html";
    }
}

module("mmManagePortal").component("mmSiteConfigurationGroupReporting", new SiteConfigurationGroupReportingComponent());
